// @ts-nocheck
import blue404 from '../assets/blue-404.png'
import green404 from '../assets/green-404.png'
import complementary404 from '../assets/complementary-404.png'
import warm404 from '../assets/warm-404.png'

import blue500 from '../assets/blue-500.png'
import green500 from '../assets/green-500.png'
import complementary500 from '../assets/complementary-500.png'
import warm500 from '../assets/warm-500.png'

import blueDataload from '../assets/blue-dataload.png'
import greenDataload from '../assets/green-dataload.png'
import complementaryDataload from '../assets/complementary-dataload.png'
import warmDataload from '../assets/warm-dataload.png'

import blueMistakes from '../assets/blue-mistakes.png'
import greenMistakes from '../assets/green-mistakes.png'
import complementaryMistakes from '../assets/complementary-mistakes.png'
import warmMistakes from '../assets/warm-mistakes.png'

import blueNocontent from '../assets/blue-nocontent.png'
import greenNocontent from '../assets/green-nocontent.png'
import complementaryNocontent from '../assets/complementary-nocontent.png'
import warmNocontent from '../assets/warm-nocontent.png'

import bluePageerror from '../assets/blue-pageerror.png'

import blueNodata from '../assets/blue-nodata.png'

const pageStatusImg = {
  'blue-404': blue404,
  'green-404': green404,
  'complementary-404': complementary404,
  'warm-404': warm404,

  'blue-500': blue500,
  'green-500': green500,
  'complementary-500': complementary500,
  'warm-500': warm500,

  'blue-dataload': blueDataload,
  'green-dataload': greenDataload,
  'complementary-dataload': complementaryDataload,
  'warm-dataload': warmDataload,

  'blue-mistakes': blueMistakes,
  'green-mistakes': greenMistakes,
  'complementary-mistakes': complementaryMistakes,
  'warm-mistakes': warmMistakes,

  'blue-nocontent': blueNocontent,
  'green-nocontent': greenNocontent,
  'complementary-nocontent': complementaryNocontent,
  'warm-nocontent': warmNocontent,

  'blue-pageerror': bluePageerror,

  'blue-nodata': blueNodata
};

export default pageStatusImg
